import { CElementType } from "@ts/ui-models";

export const normalizeCElementType = <T>(
    entity: { oldEntity: CElementType; newEntity: CElementType },
    attr: string,
    notify?: (message: string) => void,
    errory?: (value: boolean) => void
): CElementType => {
    const { oldEntity, newEntity } = entity;
    if (attr === 'customId' && newEntity.customId) newEntity.setCustomId(newEntity.customId);

    for (const key in newEntity.flavors) {
        if (!newEntity.flavors[key]) {
            delete newEntity.flavors[key];
        }
    }

    return newEntity;
};